import { format, lastDayOfMonth, startOfDay } from "date-fns";

import { typedQueryClient, useTypedQuery } from "hooks";
import { ExactFailuresQueryKeys } from "modules/ExactMonitoring/queryKeys";
import { EXACT_BILLING_STORAGE_KEYS } from "modules/ExactMonitoring/storageKeys";
import { getPreference, setPreference } from "utils/common";
import { toDate } from "utils/dateHelperFunctions";

import type { InvoicedDealersAndLocationsFilters } from "modules/ExactMonitoring/queryKeys";

const getInitialInvoicedDealersAndLocationsFilters = (): InvoicedDealersAndLocationsFilters => {
  const today = new Date();

  return {
    failed: getPreference(EXACT_BILLING_STORAGE_KEYS.FailedPreference, true),
    date_from: toDate(getPreference(EXACT_BILLING_STORAGE_KEYS.DateFromPreference, startOfDay(format(today, "yyyy-MM-01")))),
    date_to: toDate(getPreference(EXACT_BILLING_STORAGE_KEYS.DateToPreference, lastDayOfMonth(format(today, "yyyy-MM-dd"))))
  };
};

export const useInvoicedDealersAndLocationsFilters = () =>
  useTypedQuery({
    queryKey: ExactFailuresQueryKeys.invoicedDealersAndLocationsFilters,
    initialData: getInitialInvoicedDealersAndLocationsFilters
  }).data;

export const setInvoicedDealersAndLocationsFilters = (updatedFilters: InvoicedDealersAndLocationsFilters) => {
  setPreference(EXACT_BILLING_STORAGE_KEYS.FailedPreference, updatedFilters.failed);
  setPreference(EXACT_BILLING_STORAGE_KEYS.DateFromPreference, updatedFilters.date_from);
  setPreference(EXACT_BILLING_STORAGE_KEYS.DateToPreference, updatedFilters.date_to);

  typedQueryClient.setQueryData(ExactFailuresQueryKeys.invoicedDealersAndLocationsFilters, { ...updatedFilters });
};
